import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { fill: true },
  },
});

type WarningIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function WarningIcon({
  className,
  pathClassName = "fill-orange-500",
  ...props
}: WarningIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z"
        fill="#DD6B20"
        className={pathClassName}
      />
    </Svg>
  );
}

export default WarningIcon;
